import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.01
      }} className="bg-cream rounded-3xl md:rounded-[2.5rem] p-6 md:p-12 text-center border-2 border-gold/20 shadow-2xl shadow-gold/5 relative overflow-hidden" data-id="element-78">
          {/* Decorative background */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-md bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-79"></div>

          <div className="relative z-10" data-id="element-80">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-gold/10 text-gold mb-4 md:mb-6" data-id="element-81">
              <ShieldCheck className="w-8 h-8 md:w-10 md:h-10" data-id="element-82" />
            </div>

            <h2 className="text-xs md:text-sm font-bold tracking-widest text-navy/60 uppercase mb-1 md:mb-2" data-id="element-83">
              ✨ GARANTÍA KIT PROFESIONAL POSTPARTO
            </h2>
            <div className="text-4xl md:text-6xl font-bold text-navy mb-6 md:mb-8 font-serif" data-id="element-84">
              — 7 DÍAS —
            </div>

            <div className="space-y-3 md:space-y-4 text-base md:text-lg text-navy/80 mb-6 md:mb-8 max-w-xl mx-auto text-balance" data-id="element-85">
              <p data-id="element-86">
                Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu consulta
                si querés.
              </p>
              <p className="font-bold text-navy" data-id="element-87">
                Si en 7 días no es lo que esperabas: Te devolvemos el 100%.
              </p>
              <p data-id="element-88">Sin preguntas. Sin formularios. Sin drama.</p>
            </div>

            <div className="bg-white/60 rounded-xl md:rounded-2xl p-4 md:p-6 border border-navy/5 max-w-lg mx-auto" data-id="element-89">
              <p className="text-xs md:text-sm text-navy/70 italic mb-2 md:mb-3" data-id="element-90">
                La confianza que tenemos en el Kit Profesional Postparto™ nos
                permite hacer esa promesa sin dudar. Más de 300 profesionales de
                postparto de todo el país ya lo saben.
              </p>
              <div className="inline-block bg-sage/10 text-sage-700 font-bold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-xs md:text-sm" data-id="element-91">
                Tasa de devoluciones menor al 1%
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}